<template>
    <b-container fluid style="padding-left: 40px; padding-right: 40px; height: 100%;">
        <parallax :fixed="true" style="min-height: 15vh; max-height: 100vh; height: auto !important;">
            <img src="../assets/parallax_trgovci_p.jpg" alt="" style="filter: brightness(60%);">
        </parallax>

        <div>
            <h1 style="color: white;">{{ $t('common.registration') }}</h1>
            <h4 style="color: white;">{{ $t('common.registration_2') }}</h4>
        </div>

        <b-card>
            <b-card-body>
                <b-row align-h="center" >
                    <b-col style="padding-left: 50vh; padding-right: 50vh;" align-self="stretch" class="align-self-stretch">
                        <h3>{{ $t('no-certificate.text_1') }}</h3>
                        <h4 style="font-weight: normal">{{ $t('no-certificate.text_2') }}</h4>
                        <h4 style="font-weight: normal">{{ $t('no-certificate.text_3') }}</h4>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col style="padding-left: 50vh; padding-right: 50vh;" align-self="stretch" class="align-self-stretch">
                        <validation-observer v-slot="{ invalid }">
                            <b-form @submit.prevent="onSubmit" id="submitInquiryForm">
                                <b-form-group :label="$t('no-certificate.name')" label-cols="2">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-form-input v-model.trim="name"/>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group :label="$t('no-certificate.lastname')" label-cols="2">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-form-input v-model.trim="lastname"/>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group :label="$t('no-certificate.company')" label-cols="2">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-form-input v-model.trim="company"/>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group :label="$t('no-certificate.email')" label-cols="2">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-form-input v-model.trim="email"/>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>
                                <b-button name="submitButton" id="saveButton" value="Save" type="submit"> {{ $t('no-certificate.submit') }}</b-button>
                            </b-form>
                        </validation-observer>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
    import Parallax from 'vue-parallaxy'
    import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
    import {required} from "vee-validate/dist/rules";
    import i18n from "@/i18n";
    import swal from "sweetalert2";

    extend('required', {
        ...required,
        message: (_, values) => i18n.t('common.required', values)
    });

    export default {
        name: "NoCertificate",
        components: {
            Parallax,
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                name: null,
                lastname: null,
                email: null,
                company: null
            }
        },
        methods: {
            onSubmit(evt) {
                evt.preventDefault();
                let authQuery = {
                    'name': this.name,
                    'lastName': this.lastname,
                    'email': this.email,
                    'company': this.company
                };

                this.$store.dispatch('sendInquiry', authQuery)
                    .then((response) => {
                        swal.fire({
                            title: this.$t('no-certificate.title'),
                            type: 'success',
                            confirmButtonText: 'OK',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            buttonsStyling: false
                        }).then((result) => {
                            if (result.value) {
                                window.location.replace("https://mbills.si")
                            }
                        });

                    })
                    .catch(error => {
                        this.$store.commit('setError', error);
                        // TODO FIXME XXX handle different AUTH CHECK error codes!
                    })
                    .finally(() => {
                    });
            }
        }
    }
</script>

<style scoped>

</style>